import { OrderPaymethods, WompiStatus } from "@/entities/api/orders/orders"

export function WompiStatusConvert(status: WompiStatus): string {
	switch (status) {
		case WompiStatus.APPROVED:
			return 'Aprobado'
		case WompiStatus.DECLINED:
			return 'Rechazado'
		case WompiStatus.VOIDED:
			return 'Anulado'
		case WompiStatus.ERROR:
			return 'Error'
		case WompiStatus.PENDING:
			return 'Pendiente'
		default:
			return 'Estado desconocido'
	}
}

export function WompiStatusColorScheme(status: WompiStatus): string {
	switch (status) {
		case WompiStatus.APPROVED:
			return 'green'
		case WompiStatus.DECLINED:
			return 'red'
		case WompiStatus.VOIDED:
			return 'gray'
		case WompiStatus.ERROR:
			return 'red'
		case WompiStatus.PENDING:
			return 'yellow'
		default:
			return 'gray'
	}
}

export function OrderPaymethodsConvert(method: OrderPaymethods): string {
	switch (method) {
		case OrderPaymethods.card:
			return 'Tarjeta'
		case OrderPaymethods.pse:
			return 'PSE'
		case OrderPaymethods.nequi:
			return 'Nequi'
		case OrderPaymethods.cash:
			return 'Efectivo'
		case OrderPaymethods.bancolombia_transfer:
			return 'Transferencia Bancolombia'
		case OrderPaymethods.daviplata:
			return 'Daviplata'
		case OrderPaymethods.payment_on_delivery:
			return 'Pago contra entrega'
		case OrderPaymethods.none:
			return 'Sin método'
		default:
			return 'Método desconocido'
	}
}